<script>
//  弹窗组件，所欲设置的弹窗组件

export default {
    data() {
        return {
            routerTitle: {
                index     : {
                    img          : true,
                    type         : '',
                    title        : 'My component and self introduction',
                    router       : '',
                    Introduction : '',
                },
                me        : {
                    img          : true,
                    type         : 'app',
                    title        : 'introduction',
                    router       : '/me',
                    Introduction : '',
                },
                foo       : {
                    img          : true,
                    type         : 'app',
                    title        : 'vue-drag-screenshot',
                    router       : '/foo',
                    Introduction : 'A Vue component to drag-screenshot',
                },
                inputTags : {
                    img          : true,
                    type         : 'app',
                    title        : 'vue-input-tags',
                    router       : '/inputTags',
                    Introduction : 'A Vue component to input-tags',
                },
                mind : {
                    img          : true,
                    type         : 'app',
                    title        : 'vue-mind-mapping',
                    router       : '/mind',
                    Introduction : '一个类似思维导图的小工具',
                },
                threeBtn: {
                    img          : true,
                    type         : 'app',
                    title        : 'vue-3d-button',
                    router       : '/threeBtn',
                    Introduction : 'A Vue component to 3d-button',
                },
                jsFs      : {
                    img          : false,
                    type         : 'text',
                    title        : 'js 开发常用工具函数',
                    router       : '/file?type=jsFs',
                    Introduction : 'function ( ) { }',
                },
                regular   : {
                    img          : false,
                    type         : 'text',
                    title        : 'js 开发常用正则表达式',
                    router       : '/file?type=regular',
                    Introduction : 'var patt1 = new RegExp(/^[A-Z]+$/)',
                },
                vueCli   : {
                    img          : false,
                    type         : 'text',
                    title        : 'vue-cli插件开发',
                    router       : '/file?type=vueCli',
                    Introduction : 'vue-cli 3.x 开发插件并发布到 npm',
                },
                css   : {
                    img          : false,
                    type         : 'text',
                    title        : 'CSS 继承深度解析',
                    router       : '/file?type=css',
                    Introduction : '灵活，高效并且易维护的css',
                },
            },
        };
    },
}
</script>
